// extracted by mini-css-extract-plugin
module.exports = {"container":"TinkoffBankAccount__container___BWrTl","logo":"TinkoffBankAccount__logo___1Ps2E","close":"TinkoffBankAccount__close___2QDem"};